import * as React from "react";
import "./ColorInput.component.css";
import { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getRgbBrightness } from "flavr-common";
let timer;
export function ColorInput({ color, disabled, onColorChanged }) {
    const containerRef = useRef(null);
    useEffect(() => {
        const container = containerRef.current;
        if (container) {
            container.style.backgroundColor = color;
            container.style.color = getForegroundColorForBackground(color);
        }
    }, [color]);
    const getForegroundColorForBackground = (background) => {
        const rgb = background.substring(1, background.length);
        const r = parseInt(rgb.substring(0, 2), 16);
        const g = parseInt(rgb.substring(2, 4), 16);
        const b = parseInt(rgb.substring(4, 6), 16);
        const brightness = getRgbBrightness(r, g, b);
        return brightness > 155 ? "#000000" : "#FFFFFF";
    };
    const handleColorChanged = (color) => {
        if (timer) {
            clearTimeout(timer);
        }
        timer = window.setTimeout(() => {
            onColorChanged(color);
            timer = undefined;
        }, 300);
    };
    return (React.createElement("div", { className: `color-input-container ${disabled ? "color-input-container-disabled" : ""}`, ref: containerRef },
        React.createElement("input", { type: "color", value: color, disabled: disabled, onChange: (e) => {
                handleColorChanged(e.target.value);
            } }),
        !disabled && React.createElement(FontAwesomeIcon, { icon: ["fas", "palette"] })));
}
